module.exports = __webpack_public_path__ + "static/img/banner.c6fd37e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutus/banner.png
// module id = rSMJ
// module chunks = 0